
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gT98CTExFtQ2UAmB_BRmPBTjB7WBoBSqF_h2SXiGJ2UYMeta } from "/codebuild/output/src3318328745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index5ITKQ6iAa_lFejm1IUvm_WjSk8hlVpd4mZIFph0I0CYMeta } from "/codebuild/output/src3318328745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchjq24XkokHFJaega_45zEJjV_11Ds_45r4DnDuJCgfE5Ar4cMeta } from "/codebuild/output/src3318328745/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexuuy6tiH_45U4hMXsfBPf2srY_Lav5aTO0u7YY_45tFqAje4Meta } from "/codebuild/output/src3318328745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93IfC8IqVbIHmxb57lmHYevqHJqLeNnhj4V9EAKnhZh1kMeta } from "/codebuild/output/src3318328745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexKb8KVb74moY5LYE1aB52u_I0mAfz0RJquqA1nhB72MkMeta } from "/codebuild/output/src3318328745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93it30lxGP0TiCozOGKcl3E5CS4DNZFBhxSuYBcTij_45G8Meta } from "/codebuild/output/src3318328745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexO8sVwSUGTrWrVNigFcDhLUhnt7HFs_urJ__456_LI8Q8wMeta } from "/codebuild/output/src3318328745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93EyErO9u4L_45FoOSeJOzjo1fwgk9rcSTsR5EtMhuaW4mYMeta } from "/codebuild/output/src3318328745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexsN2vDxwii8OcK0smAca74wYq2YHbNhOw0mGyFZ4cfLcMeta } from "/codebuild/output/src3318328745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexVIuS0GHQvkDVT9JItSDGROor_gYtas4sm_45wQaL466x4Meta } from "/codebuild/output/src3318328745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3318328745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3318328745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3318328745/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3318328745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3318328745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexKb8KVb74moY5LYE1aB52u_I0mAfz0RJquqA1nhB72MkMeta || {},
    component: () => import("/codebuild/output/src3318328745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3318328745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexO8sVwSUGTrWrVNigFcDhLUhnt7HFs_urJ__456_LI8Q8wMeta || {},
    component: () => import("/codebuild/output/src3318328745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3318328745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexsN2vDxwii8OcK0smAca74wYq2YHbNhOw0mGyFZ4cfLcMeta || {},
    component: () => import("/codebuild/output/src3318328745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexVIuS0GHQvkDVT9JItSDGROor_gYtas4sm_45wQaL466x4Meta || {},
    component: () => import("/codebuild/output/src3318328745/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]